import React, { useState, useEffect, useRef } from "react";
import { Editor as TinyMCE } from "@tinymce/tinymce-react";

import ReactHtmlParser from "react-html-parser";
//  Ya no usamos react-draft-wysiwyg / draft-js
// import { Editor } from "react-draft-wysiwyg";
// import { EditorState } from "draft-js";
// import { stateToHTML } from "draft-js-export-html";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"; // puedes quitar esta línea si ya no usas ese CSS
const TINYMCE_KEY = "19e5gcrv99gsbghdejcrmsqrjrmx2nn39c5yh4nlk7tuvo0h";
function Customizable(props) {
  const [loaded, setLoaded] = useState(false);
  const [name] = useState(props.name);
  const [value, setValue] = useState("");
  const [canEdit, setCanEdit] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const editorRef = useRef(null);

  useEffect(() => {
    const storedLoginId = localStorage.getItem("userLoginId");
    if (storedLoginId && parseInt(storedLoginId, 10) === 1) {
      setCanEdit(true);
    }
  }, []);

  const reloadContent = () => {
    fetch("/PageContent?Name=" + name, { method: "GET" })
      .then((r) => r.text())
      .then((html) => {
        setValue(html || "");
        setLoaded(true);
      })
      .catch(console.error);
  };

  useEffect(() => {
    reloadContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Auto-guardado al editar (igual que antes)
  const save = (newValue) => {
    setValue(newValue);
    fetch("/PageContent", {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ Name: name, Value: newValue }),
    }).catch(console.error);
  };

  return (
    <div
      onDoubleClick={() => {
        if (!canEdit) return console.log("User is not allowed to edit.");
        const next = !isEditing;
        setIsEditing(next);
        if (!next) {
          // si salgo de edición, recargo lo del servidor
          reloadContent();
        }
      }}
    >
      {loaded && !isEditing && <span>{ReactHtmlParser(value)}</span>}
      {!loaded && <span>Loading ...</span>}

      {isEditing && canEdit && (
        <div className="container">
          <TinyMCE
            // Carga Tiny desde CDN (sin API key para dev)
            onInit={(_evt, editor) => (editorRef.current = editor)}
            value={value}
            apiKey={TINYMCE_KEY}
            onEditorChange={(content /*, editor */) => save(content)}
            init={{
              height: 380,
              menubar: false,
              plugins: "table lists link code ",
              toolbar:
                "undo redo | blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link | removeformat| code",
              style_formats: [
                { title: "Hanging indent (–)", selector: "p,li", classes: "hanging-indent" }
              ],
                table_toolbar:
                "tableprops cellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | tablemergecells tablesplitcells",
              content_style: `
                body { font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial, sans-serif; font-size:14px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #ddd; padding: 6px; }
                .hanging-indent{padding-left:0.7em;text-indent:-0.7em;margin:0; }
                .hanging-indent.no-dash{position:relative;}
                .hanging-indent.no-dash::before{content:"– "; position:absolute; left:0;}
              `,
              // Opcional: pega limpio desde Word/Excel
              paste_data_images: false,
              extended_valid_elements: 'p[class],li[class],td[class]',
            }}
          />
        </div>
      )}
    </div>
  );
}

export default Customizable;
